/**
 * Idle session and proactive OAuth refresh timing (CRA env, build-time).
 * Values are always whole minutes. Legacy env keys still work if new ones are unset.
 */
const minutesFromEnv = (primaryKey, legacyKey, fallbackMinutes) => {
  let n = parseInt(process.env[primaryKey], 10);
  if (!Number.isFinite(n) || n <= 0) {
    n = parseInt(process.env[legacyKey], 10);
  }
  if (!Number.isFinite(n) || n <= 0) {
    return fallbackMinutes;
  }
  return n;
};

/** Minutes of user inactivity before idle logout flow starts. */
export const getIdleSessionMinutes = () =>
  minutesFromEnv('REACT_APP_IDLE_SESSION_MINUTES', 'REACT_APP_TIME_OUT_TO_NOTIFY_IN_MILISECONDS', 21);

/** Minutes before idle logout when the warning modal appears (remaining time ≤ this). */
export const getIdleWarningMinutes = () =>
  minutesFromEnv('REACT_APP_IDLE_WARNING_MINUTES_BEFORE_LOGOUT', 'REACT_APP_TIME_TO_SHOW_THE_TIMER_IN_SECONDS', 1);

/** Minutes between proactive refresh-token calls (leader tab only). */
export const getTokenRefreshIntervalMinutes = () => {
  const primary = parseInt(process.env.REACT_APP_TOKEN_REFRESH_INTERVAL_MINUTES, 10);
  if (Number.isFinite(primary) && primary > 0) {
    return primary;
  }
  const legacySeconds = parseInt(process.env.REACT_APP_REFRESH_TOKEN_INTERVAL_IN_SECONDS, 10);
  if (Number.isFinite(legacySeconds) && legacySeconds > 0) {
    return Math.max(1, Math.round(legacySeconds / 60));
  }
  return 12;
};

export const getRefreshTokenIntervalSeconds = () => getTokenRefreshIntervalMinutes() * 60;

/** Axios timeout for POST /oauth/refreshtoken (ms). Primary env is minutes for consistency. */
export const getOAuthRefreshHttpTimeoutMs = () => {
  const min = parseFloat(process.env.REACT_APP_OAUTH_REFRESH_HTTP_TIMEOUT_MINUTES);
  if (Number.isFinite(min) && min > 0) {
    return Math.round(min * 60 * 1000);
  }
  const sec =
    parseInt(process.env.REACT_APP_OAUTH_REFRESH_HTTP_TIMEOUT_SECONDS, 10) ||
    parseInt(process.env.REACT_APP_REFRESH_TOKEN_TIMEOUT_SECONDS, 10);
  if (Number.isFinite(sec) && sec > 0) {
    return sec * 1000;
  }
  return 30 * 1000;
};

export const getIdleNotifyMs = () => getIdleSessionMinutes() * 60 * 1000;

export const getIdleTimerShowSeconds = () => getIdleWarningMinutes() * 60;
